<template>
  <div>
    <template v-if="!isDownloadFormEnabled">
      <div class="download-list">
        <div class="download-list-item" v-for="d in downloads" :key="d._id">
          <div class="download-img"></div>
          <div class="download-info-wrapper">
            <div class="download-name">
              <a :href="d.filePath" target="_blank">{{d.name}}</a>
            </div>
            <div class="download-actions">
              <Button class="download-delete-btn" icon="ios-trash" shape="circle"></Button>
            </div>
          </div>
        </div>
        <Button class type="primary" @click="enableDownloadForm()">Add New File</Button>
      </div>
    </template>
    <template v-if="isDownloadFormEnabled">
      <div class="download-form">
        <Form :model="downloadFormData">
          <FormItem label="File">
            <Upload
              :action="uploadServer"
              :on-success="handleUpload"
              :format="['pdf','doc','docx','xls', 'xlsx']"
              :max-size="100000"
            >
              <Button icon="ios-cloud-upload-outline">Upload</Button>
            </Upload>
          </FormItem>
          <FormItem label="Name">
            <Input v-model="downloadFormData.name" />
          </FormItem>
          <Button type="primary" @click="saveDownload()">Save</Button>
          <Button>Cancel</Button>
        </Form>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import $config from "@/config";

export default {
  name: "Downloads",
  data() {
    return {
      form: {},
      downloadFormData: {},
      isDownloadFormEnabled: false,
      downloadUrl: null
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("download", {
      findDownloadsInStore: "find"
    }),
    uploadServer() {
      return $config.uploadServer;
    },
    downloads() {
      console.log(
        this.findDownloadsInStore({ webcastId: this.webcast._id }).data
      );
      return this.findDownloadsInStore({ webcastId: this.webcast._id }).data;
    }
  },
  methods: {
    ...mapActions("download", {
      findDownloadsAction: "find",
      updateDownloadsAction: "update",
      createDownloadsAction: "create",
      removeDownloadsAction: "remove"
    }),
    enableDownloadForm() {
      this.isDownloadFormEnabled = true;
    },
    handleUpload(res, file) {
      console.log(res);
      console.log(file);
      this.$set(this.$data, "downloadUrl", res);
    },
    saveDownload() {
      const payload = {
        webcastId: this.webcast._id,
        filePath: this.downloadUrl,
        name: this.downloadFormData.name
      };
      this.createDownloadsAction(payload).then(speaker => {
        this.$Message.success("File has been saved");
        this.isDownloadFormEnabled = false;
      });
    }
  },
  created() {
    this.findDownloadsAction({ query: { webcastId: this.webcast._id } });
  }
};
</script>

<style lang="less">
.download-list {
  margin-bottom: 24px;
}
.download-list-item {
  height: 84px;
  margin-bottom: 12px;
}
.download-img {
  float: left;
  margin-right: 12px;
  img {
    width: 72px;
    height: 72px;
    border-radius: 48px;
  }
}
.download-info-wrapper {
  padding-left: 14px;
  padding-top: 14px;
}
.download-name {
  font-size: 14px;
}
.download-actions {
  float: right;
  top: -32px;
  position: relative;
}
</style>
